/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
export const fadeAndSlideInKeyframes = [
    { opacity: 0, transform: 'translateY(-15rem)' },
    { opacity: 1, transform: 'translateY(0)' },
];
